module.exports = "<p>data works!</p>\n"